import React from 'react';

import { convertStyleData } from '@utils/tools';

import './AudioCustomComponent.less';

export default class AudioCustomComponent extends React.Component {
  
  state = {
    isPlay: false,
    duration: 0,
    currentTime: 0
  }

  constructor(props) {
    super(props);
    this.audioRef = React.createRef();
  }
  /**
   * 更改播放状态
   */
  changeIsPlay = () => {
    let $audio = this.audioRef.current;
    let isPlay = this.state.isPlay; // 当前播放状态： true: play / false: pause
    this.setState({
      isPlay: !isPlay
    })
    if (isPlay) {
      // 状态更改：play => pause
      $audio.pause(); 
    } else {
      // 状态更改：pause => play
      $audio.play();
    }
  }
  /**
   * 设置音频时长
   */
  setAudioDuration = () => {
    this.setState({
      duration: this.audioRef.current.duration
    });
  }
  /**
   * 设置当前时间
   */
  setCurrentTime = () => {
    let $audio = this.audioRef.current;
    this.setState({
      currentTime: $audio.currentTime
    });
    if ($audio.currentTime == $audio.duration) {
      this.setState({
        isPlay: false
      })
    }
  }
  /**
   * 转换时间
   */
  millisecondToDate(time) {
    let second = Math.floor(time % 60);
    let minite = Math.floor(time / 60);
    return `${minite >= 10 ? minite : `0${minite}`}:${second >= 10 ? second : `0${second}`}`;
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    const detailData = this.props.detailData;    // 详情页数据
    const dynamicData = this.props.dynamicData;  // 动态数据
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    /**
     * 组件内容处理
     */   
    let content = data.content;
    const segment = data.customFeature.segment; // 已绑定字段
    // 是否有绑定字段
    if (segment) {
      if (detailData && detailData[segment]) {
        content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
      } else if (dynamicData && dynamicData[segment]) {
        content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
      }
    }
    /**
     * 返回组件
     */ 
    return (
      <div className="custom-component audio" style={styleObj} onClick={this.changeIsPlay}>
        <div className="poster">
          <img src={customFeature['background-thumb']} />
          <div className="control">
            <span className={this.state.isPlay ? 'pause' : 'play'}></span>
          </div>
        </div>
        <div className="content">
          <div className="name">{customFeature['file-name']}</div>
          <div className="author">{customFeature.audioAuthor}</div>
          <div className="time">{this.state.currentTime === 0 ? this.millisecondToDate(this.state.duration) : this.millisecondToDate(this.state.currentTime)}</div>
        </div>
        <audio ref={this.audioRef} src={customFeature['file-src']} preload="metadata" onCanPlay={this.setAudioDuration} onError={this.setAudioDuration} onTimeUpdate={this.setCurrentTime}></audio>
      </div>
    );
        
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/audio-custom-component/AudioCustomComponent.jsx